import { Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const PackageDetailsModal = ({ open, onClose }) => {
  const features = [
    { title: "Teljes weboldal szövegezés (headline-ok, alcímek, CTA-k, microcopy)", desc: "Megírjuk a teljes tartalmat, ami értékesít." },
    { title: "Konverziós felépítés: szekciók logikája + kifogáskezelő GYIK", desc: "Bevált struktúra, ami szolgáltatóknál működik." },
    { title: "Szolgáltatás szekció kártyákkal (érthetően, gyorsan átláthatóan)", desc: "A látogató azonnal érti, mit kínálsz." },
    { title: "3 lépéses folyamat blokk (bizalom és kiszámíthatóság)", desc: "Csökkenti a bizonytalanságot az érdeklődőnél." },
    { title: "Kattintható CTA-k: gombok, sticky CTA mobilon", desc: "Könnyű kapcsolatfelvétel minden eszközön." },
    { title: "Google térkép beágyazás (ha van cím / terület)", desc: "Lokális szolgáltatóknál növeli a bizalmat." },
    { title: "Képgaléria / referencia blokk (ha adsz anyagot)", desc: "Vizuális bizonyíték a munkáidról." },
    { title: "YouTube videó beágyazás (ha van videód — opcionális)", desc: "Videó tartalom integrációja." },
    { title: "Alap analitika mérés (alap szintű látogatottsági mérés beállítás)", desc: "Látod, honnan jönnek a látogatók." },
    { title: "Átadás után kérhető gyors módosítások (egyeztetés szerint)", desc: "Rugalmas finomhangolás a bevezetés után." }
  ];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-ink border border-white/10 text-on-dark max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-sora text-2xl">Mit tartalmaz pontosan?</DialogTitle>
          <DialogDescription className="text-on-dark/60">
            Prémium Landing csomag - 97 000 Ft
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          {features.map((feature, i) => (
            <div key={i} className="p-4 rounded-xl bg-white/5 border border-white/5">
              <div className="flex items-start gap-3">
                <Check size={18} className="text-accent mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-on-dark font-medium">{feature.title}</p>
                  <p className="text-on-dark/60 text-sm mt-1">{feature.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PackageDetailsModal;
